import { useTranslation } from "next-i18next";

import { ICONS } from "../../icons";
import Header from "../../text/header";
import { PublicArticleLink } from "../types/article";
import { CONSUMER_URL_PREFIX, MERCHANT_URL_PREFIX, getHelpArticleUrl } from "../utils";
import ArticleTile from "./article-tile";
import styles from "./child-articles.module.scss";

type Props = {
    childArticles?: PublicArticleLink[];
    type?: "consumer" | "merchant";
};

export const ChildArticles = ({ childArticles, type = "consumer" }: Props) => {
    const { t } = useTranslation();

    if (!childArticles?.length) {
        return null;
    }

    const urlPrefix = type === "merchant" ? MERCHANT_URL_PREFIX : CONSUMER_URL_PREFIX;

    return (
        <section className={styles.section}>
            <Header
                renderAs="h6"
                title={t("help.interestedArticles.title")}
                className={styles.title}
            />
            <div className={styles.browseList}>
                {childArticles.map((article) =>
                    article ? (
                        <ArticleTile
                            key={article.slug}
                            title={article.title}
                            href={getHelpArticleUrl(urlPrefix, article.token, article.slug)}
                            leftIcon={
                                <div className={styles.iconWrapper}>
                                    <ICONS.Document color="currentColor" />
                                </div>
                            }
                            rightIcon={
                                <div className={styles.iconWrapper}>
                                    <ICONS.Push color="currentColor" />
                                </div>
                            }
                        />
                    ) : null
                )}
            </div>
        </section>
    );
};
